<template>
  <PCard class="min-h-screen">
    <template #title>
      <div class="flex align-items-center justify-content-between">
        <WTitle text="Settings" />
      </div>
    </template>
    <template #content>
      <PDivider class="mb-2" />
      <!-- <WTheme />
      <PDivider class="mb-2" /> -->
      <WMenuPosition />
      <PDivider class="mb-2" />
      <WToastPosition />
      <PDivider class="mb-2" />
      <div
        id="alert-sound"
        class="settings-anchor"
        :class="{ 'settings-anchor--highlight': highlightAlertSound }"
      >
        <WStatusAlertMute />
        <PDivider class="mb-2" />
        <WStatusAlertSound />
      </div>
      <PDivider class="mb-2" />
    </template>
  </PCard>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import WTheme from '@/components/settings/WTheme.vue'
  import WMenuPosition from '@/components/settings/WMenuPosition.vue'
  import WToastPosition from '@/components/settings/WToastPosition.vue'
  import WStatusAlertMute from '@/components/settings/WStatusAlertMute.vue'
  import WStatusAlertSound from '@/components/settings/WStatusAlertSound.vue'

  const HIGHLIGHT_MS = 2600

  export default defineComponent({
    name: 'SettingsView',
    components: {
      WTheme,
      WMenuPosition,
      WToastPosition,
      WStatusAlertMute,
      WStatusAlertSound,
    },

    data: () => ({
      highlightAlertSound: false,
      highlightTimer: null as ReturnType<typeof setTimeout> | null,
    }),

    mounted() {
      this.focusHashTarget()
    },

    beforeUnmount() {
      this.clearHighlightTimer()
    },

    watch: {
      '$route.hash'() {
        this.focusHashTarget()
      },
    },

    methods: {
      clearHighlightTimer() {
        if (this.highlightTimer) {
          clearTimeout(this.highlightTimer)
          this.highlightTimer = null
        }
      },

      focusHashTarget() {
        const hash = this.$route.hash
        if (hash !== '#alert-sound') {
          this.highlightAlertSound = false
          this.clearHighlightTimer()
          return
        }

        this.$nextTick(() => {
          const el = document.querySelector(hash)
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
          this.clearHighlightTimer()
          // Retrigger CSS animation if the user navigates here again.
          this.highlightAlertSound = false
          this.$nextTick(() => {
            this.highlightAlertSound = true
            this.highlightTimer = setTimeout(() => {
              this.highlightAlertSound = false
              this.highlightTimer = null
            }, HIGHLIGHT_MS)
          })
        })
      },
    },

  })
</script>

<style scoped>
.settings-anchor {
  border-radius: 0.5rem;
  padding: 0.35rem 0.5rem;
  margin: 0 -0.5rem;
  transition: background-color 0.35s ease, box-shadow 0.35s ease;
}

.settings-anchor--highlight {
  animation: settings-anchor-pulse 2.6s ease-out 1;
  background: color-mix(in srgb, var(--primary-color, #3b82f6) 12%, transparent);
  box-shadow:
    0 0 0 2px color-mix(in srgb, var(--primary-color, #3b82f6) 55%, transparent),
    0 0 0 6px color-mix(in srgb, var(--primary-color, #3b82f6) 18%, transparent);
}

@keyframes settings-anchor-pulse {
  0% {
    background: color-mix(in srgb, var(--primary-color, #3b82f6) 22%, transparent);
    box-shadow:
      0 0 0 2px color-mix(in srgb, var(--primary-color, #3b82f6) 75%, transparent),
      0 0 0 10px color-mix(in srgb, var(--primary-color, #3b82f6) 28%, transparent);
  }
  100% {
    background: transparent;
    box-shadow:
      0 0 0 0 transparent,
      0 0 0 0 transparent;
  }
}
</style>
